<template>
  <div>
    <h1>Service Cycle</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- H1 & H2 Comparison Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">H1 & H2 Comparison</h5>
      <h1h2-comparison
        :filterUrl="filterUrl"
      ></h1h2-comparison>
    </div>
    <!-- H1 & H2 Comparison End -->

    <!-- Average Service Cycle Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Average Service Cycle</h5>
      <average-service-cycle
        :filterUrl="filterUrl"
      ></average-service-cycle>
    </div>
    <!-- Average Service Cycle End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import h1h2Comparison from './children/h1h2Comparison'
  import averageServiceCycle from './children/averageServiceCycle'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      h1h2Comparison,
      averageServiceCycle,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>